import React from 'react'
import styled from'styled-components'

const Messages = () => {
  return (
    
    <Container>
        MESSAGE CONTAINER
    </Container>
    
  )
}

const Container = styled.div`
height:67vh;
overflow:hidden;
background-color:pink;
z-index:-1;
overflow:auto;
`




export default Messages
